import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[tiTrimValue]',
})
export class TrimValueDirective {
  constructor() {}

  @HostListener('focusout', ['$event'])
  onKeyDown(event: FocusEvent) {
    const input = event.target as HTMLInputElement;

    input.value = !input.value ? '' : input.value.trim();
  }
}
